import { MainLayout } from "@/components/layout/MainLayout";
import { AuthorPageContent } from "@/components/modules/Author/AuthorPageContent";
import { wrapper } from "@/core/store/store";
import isValidContextForPageProps from "@/core/utils/isValidContextForPageProps";
import provideGlobal from "@/connectors/fcWordpress/provideGlobal";
import provideAuthorBySlug from "@/connectors/fcWordpress/thunks/ProvideAuthorBySlug";
import { DataRequestType } from "@/core/types/dataRequestsTypes";
import providePostsByAuthorSlug from "@/connectors/fcWordpress/thunks/ProvidePostsByAuthorSlug";
import useAuthorBySlugProvider from "@/core/dataProviders/providers/authors/useAuthorBySlugProvider";
import { useRouter } from "next-translate-routes";

export default function AuthorPage() {
  const router = useRouter();
  const slug = router.query["slug"];

  const [author, authorReqState] = useAuthorBySlugProvider(slug ? { slug: slug as string } : null);

  return (
    <>
      <MainLayout>
        <AuthorPageContent author={author!} />
      </MainLayout>
    </>
  );
}

// This gets called on every request
export const getServerSideProps = wrapper.getServerSideProps((store) => async (context) => {
  if (!isValidContextForPageProps(context) && context.query && !Array.isArray(context.query.slug)) {
    return { props: {} };
  }

  const slug = context.query["slug"] as string;
  const locale = context.locale === "default" ? process.env.NEXT_PUBLIC_DEFAULT_API_LANGUAGE_CODE! : context.locale!;
  try {
    const [, author] = await Promise.all([
      provideGlobal(locale!, store.dispatch),
      provideAuthorBySlug(
        {
          type: DataRequestType.AUTHOR_BY_SLUG,
          language: locale,
          sign: { slug },
        },
        store.dispatch
      ),
      providePostsByAuthorSlug(
        {
          type: DataRequestType.POSTS_BY_AUTHOR_SLUG,
          language: locale,
          //TODO: perPage
          sign: { slug: slug, pageNumber: 1, perPage: 20 },
        },
        store.dispatch
      ),
    ]);

    if (!author) {
      return {
        notFound: true,
      };
    }
  } catch {
    return { props: {} };
  }

  return { props: {} };
});
